/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-12-07 13:57:47
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-12-12 17:24:44
 * @FilePath: \szsc_ipark_device_admin(contractadmin)\src\area-base\store\workflow.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 工作流信息存储使用
// 单纯用于页面跳转时存储信息，不从后台重新获取
export default {
  state: {
    workflowData: {}, // 工作流数据,以列表中查询到的数据id为key，具体数据为data
    reWorkflowData: {}, // 重新发起时获取的工作流数据
    newWorkflowData: {} // 重新发起后更新工作流使用数据
  },
  getters: {
    workflowData (state) {
      return state.workflowData
    },
    reWorkflowData (state) {
      return state.reWorkflowData
    },
    newWorkflowData (state) {
      return state.newWorkflowData
    }
  },
  mutations: {
    setWorkflowData (state, data) {
      if (data.id) {
        state.workflowData[data.id] = data
      }
    },
    getWorkflowData (state, id) {
      return state.workflowData[id] ? state.workflowData[id] : {}
    },
    setReWorkflowData (state, data) {
      if (data.id) {
        state.reWorkflowData[data.id] = data
      }
    },
    getReWorkflowData (state, id) {
      return state.reWorkflowData[id] ? state.reWorkflowData[id] : {}
    },
    setNewWorkflowData (state, data) {
      if (data.id) {
        state.newWorkflowData[data.id] = data
      }
    },
    getNewWorkflowData (state, id) {
      return state.newWorkflowData[id] ? state.newWorkflowData[id] : {}
    }
  },
  actions: {
    setWorkflowData ({commit}, data) {
      commit('setWorkflowData', data)
    },
    getWorkflowData ({commit}, id) {
      return commit('getWorkflowData', id)
    },
    setReWorkflowData ({commit}, data) {
      commit('setReWorkflowData', data)
    },
    getReWorkflowData ({commit}, id) {
      return commit('getReWorkflowData', id)
    },
    setNewWorkflowData ({commit}, data) {
      commit('setNewWorkflowData', data)
    },
    getNewWorkflowData ({commit}, id) {
      return commit('getNewWorkflowData', id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/store/workflow.js